import { useMemo } from "react";
import FilterContent from "../../../../components/Filter/FilterContent";
import PopOver from "../../../../components/View/PopOver";
import { IconAdjustmentsHorizontal, IconX } from "@tabler/icons-react";
import { Button, Group, Indicator, Tooltip } from "@mantine/core";
import { useLanguage } from "../../../../stores/LanguageStore";
import { getWorkflows } from "../../../../api/WorkflowAPI";
import { nodeActions } from "../../workflows/CreateCampaign/flow/flowSettings";

const CampaignsTableFilter = ({ filter, setFilter }) => {
  const lang = useLanguage((s) => s.language);

  const fields = useMemo(() => {
    return [
      {
        label: "-",
        options: [
          {
            option_name: lang.prm.filter_labels.contains_step,
            name: lang.prm.filter_labels.contains_step,
            type: "boolean",
            id: "contains_step",
            filterable: true,
            field: "contains_step",
            disabledCondition: true,
            options: [...nodeActions, "call"]
              .filter((x) => x !== "linkedin_visit" && x !== "linkedin_vocal")
              .map((action) => ({
                label:
                  action === "linkedin"
                    ? "LinkedIn"
                    : action === "call"
                      ? lang.workflows.explorer.all_elements.call
                      : action === "split_contacts"
                        ? lang.workflows.explorer.all_elements.split_contacts
                        : lang.routes.models[action],
                value: action,
              })),
          },
          {
            option_name: lang.prm.filter_labels.workflow,
            name: lang.prm.filter_labels.workflow,
            type: "lazy",
            id: "workflow_id",
            options: [],
            filterable: true,
            field: "workflow_id",
            getter: getWorkflows,
            responseField: "workflows",
            storeKey: "workflowOptions",
            setStoreKey: "setWorkflowOptions",
            nameField: "name",
            disabledCondition: true,
          },
          {
            option_name: lang.statistics.columns.date_start,
            name: lang.statistics.columns.date_start,
            type: "date",
            id: "date_start",
            filterable: true,
            field: "date_start",
          },
        ],
      },
    ];
  }, []);

  return (
    <Group gap={0} ml={16}>
      <PopOver
        opener={(openFunction, ref) => {
          return (
            <Group gap={0}>
              <Tooltip label={lang.table.toolbar.filter.main_button_tooltip}>
                <Button
                  ref={ref}
                  onClick={openFunction}
                  radius={"md"}
                  variant={"subtle"}
                  className="test"
                  style={{
                    borderColor: "var(--mantine-color-primary-0)",
                    background: "#fff",
                    borderTopRightRadius: filter?.values?.length > 0 ? 0 : 8,
                    borderBottomRightRadius: filter?.values?.length > 0 ? 0 : 8,
                  }}
                  id={"table-filter-prm"}
                >
                  <Indicator
                    color="red"
                    offset={2}
                    disabled={!filter || filter?.values?.length === 0}
                    label={filter?.values?.length}
                    styles={{
                      indicator: {
                        fontSize: 9,
                        padding: "6px",
                      },
                    }}
                  >
                    <IconAdjustmentsHorizontal size={20} />
                  </Indicator>
                  <span style={{ marginLeft: 6 }}>
                    {lang.table.toolbar.filter.main_button_label}
                  </span>
                </Button>
              </Tooltip>
              {filter?.values?.length > 0 && (
                <Tooltip
                  label={lang.table.toolbar.filter.cancel_button_tooltip}
                >
                  <Button
                    variant="light"
                    color="red"
                    px={4}
                    style={{
                      borderLeft: "none",
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0,
                    }}
                    onClick={() => setFilter(null)}
                  >
                    <IconX size={18} />
                  </Button>
                </Tooltip>
              )}
            </Group>
          );
        }}
        popoverChildren={(handleClose) => (
          <FilterContent
            id={"campaign-filter"}
            pageName={"statistics"}
            isClient={false}
            mainFilter={filter}
            setMainFilter={(newFilter) => {
              setFilter(newFilter);
              handleClose();
            }}
            fields={fields}
            getFieldOptionName={(f) => f.option_name}
          />
        )}
        elevation={3}
        paperSx={{
          ml: -12,
        }}
      />
    </Group>
  );
};

export default CampaignsTableFilter;
